import { AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';

export class ValidationLogic {

    /**
     * Determines if the control's value is considered empty or whitespace only.
     * @param control
     */
    public static isNullOrWhiteSpace(control: AbstractControl): boolean {
        return (!control || control.value === undefined || control.value === null || String(control.value).trim() === '');
    }

     /**
      * Verifies a control's value matches a number format of nnnn, where n can be any number of digits
      *  without any decimal points (no fractional numbers).
      * @param control
      * @param allowNegative should negative values be allowed?
      */
    public static isInteger(control: AbstractControl, allowNegative: boolean = false): boolean {
        let positiveOnlyPattern: RegExp = /^\d+$/gi;
        let wholeNumberPattern: RegExp = /^-?\d+$/gi;

        return ValidationLogic.isPattern(control, allowNegative ? wholeNumberPattern : positiveOnlyPattern);
    }

    public static isPattern(control: AbstractControl, pattern: RegExp): boolean {
        // we must have a control, and that control's value must either be null or pass the regex test to be valid.
        if (control && (control.value === undefined || control.value === null || pattern.test(control.value))) {
            return true;
        }

        return false;
    }

    /**
     * Verifies a control's value matches a number format of nnnn.mmmm, where n can be any number of digits
     *  followed by one decimal point (or none), and any number of digits after the decimal point.
     * @param control
     * @param allowNegative should negative values be allowed?
     */
    public static isNumber(control: AbstractControl, allowNegative: boolean = false): boolean {
        let positiveOnlyPattern: RegExp = /^((\d+\.?\d*)|(\d?\.\d+))$/gi;
        let wholeNumberPattern: RegExp = /^-?((\d+\.?\d*)|(\d?\.\d+))$/gi;

        return ValidationLogic.isPattern(control, allowNegative ? wholeNumberPattern : positiveOnlyPattern);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/validation-logic.ts